<template>
  <div>
    <div
      v-if="myPendingProspects.length === 0"
      class="text-center py-12 text-gray-500 dark:text-gray-400"
    >
      <svg
        class="mx-auto h-12 w-12 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900 dark:text-white">
        Geen verzoeken voor jouw team(s)
      </h3>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Er zijn geen wachtende verzoeken voor jouw team(s).
      </p>
    </div>

    <div v-else class="grid gap-3 sm:gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <ProspectCard
        v-for="prospect in myPendingProspects"
        :key="prospect.id"
        :prospect="prospect"
        :badge="`${prospect.preference_count} rol${prospect.preference_count === 1 ? '' : 'len'}`"
        badge-class="bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300"
        :status-badge="prospect.reassess_comment ? 'Herbeoordeling' : null"
        :status-badge-class="
          prospect.reassess_comment
            ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300'
            : undefined
        "
        :border-color="prospect.reassess_comment ? 'border-amber-500' : 'border-blue-500'"
        @click="$emit('open-review', prospect)"
      >
        <template #badge-extra>
          <span
            v-if="prospect.responsible_team_name"
            class="text-xs px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
          >
            {{ prospect.responsible_team_name }}
          </span>
        </template>
        <template #footer>
          <div class="flex items-center text-sm text-gray-500 dark:text-gray-400">
            <UserIcon class="h-4 w-4 mr-1.5 text-gray-400 dark:text-gray-500" />
            <span
              >Aangeboden door
              <span class="font-medium text-gray-700 dark:text-gray-300">{{
                prospect.submitted_by_name || 'Onbekend'
              }}</span></span
            >
          </div>
          <div class="flex items-center text-xs text-gray-400 dark:text-gray-500 mt-1">
            <ClockIcon class="h-3.5 w-3.5 mr-1" />
            <span>{{ formatDateTime(prospect.submitted_at) }}</span>
          </div>
        </template>
      </ProspectCard>
    </div>
  </div>
</template>

<script setup>
import { ClockIcon, UserIcon } from '@heroicons/vue/24/outline'
import ProspectCard from '@/components/common/cards/ProspectCard.vue'

defineProps({
  myPendingProspects: {
    type: Array,
    required: true
  },
  formatDateTime: {
    type: Function,
    required: true
  }
})

defineEmits(['open-review'])
</script>
